import request from "@/CommonDP/utils/request";
export default {
    // 发送验证码
    smssendVerifyCode(data) {
        return request.post("/sms/sendVerifyCode", data)
            .then(res => res)
    },
    //用户注册
    userregister(data) {
        return request.post("/user/register", data)
            .then(res => res)
    },
    //用户登录
    loginByUsername(params) {
        return request.post('/login', params).then(res => res)
    },
    smscheckVerifyCode(data) {
        return request.post('/sms/checkVerifyCode', data)
            .then(res => res)
    },
    getInviteJoinEnterpriseList() {
        return request.get(`/user/getInviteJoinEnterpriseList`)
            .then(res => res)
    },
    // 判断手机号是否注册且判断有没有名字 res.data 0未注册 1是已注册 有名字 2已注册 没有名字
    userexists(data) {
        // 返回数据是数字类型
        return request.post("/user/getPhoneStatus", data)
            .then(res => res)
    },
    jointrial(data) {
        return request.post('/enterprise/join/trial', data)
            .then(res => res)
    },
}